import { MinistryPersonGroupDto as ApiMinistryPersonGroupDto, type MinistryStatus } from '../generated/api-client';
import {
  Ministries,
  MinistryPersonGroupDto,
  PersonMinistryDto,
} from '../../../features/units/models/unit.model';

const MINISTRY_ORDER = ['Apóstol', 'Pastor', 'Diácono'] as const;
type KnownMinistry = typeof MINISTRY_ORDER[number];

/**
 * Convierte un MinistryPersonGroupDto generado por NSwag al tipo de dominio local.
 * El `ministryId` de cada persona se hereda del grupo ya que el DTO generado
 * de PersonMinistryDto no lo expone individualmente.
 */
export function mapMinistryGroup(dto: ApiMinistryPersonGroupDto): MinistryPersonGroupDto {
  return {
    ministryId: dto.ministryId ?? 0,
    ministryName: dto.ministryName ?? '',
    sortOrder: dto.sortOrder ?? 0,
    people: (dto.people ?? []).map(p => ({
      personId: p.personId ?? '',
      firstName: p.firstName ?? '',
      lastName: p.lastName ?? '',
      ministryId: dto.ministryId ?? 0,
      ministryName: p.ministryName ?? '',
      status: p.status ?? '',
      unitId: p.unitId,
      unitName: p.unitName,
    })),
  };
}

/**
 * Convierte un PersonMinistryDto (dominio) al tipo Ministries usado
 * en componentes de visualización de portadores de ministerio.
 */
export function mapPersonMinistryToMinistries(dto: PersonMinistryDto): Ministries {
  const knownMinistries: string[] = [...MINISTRY_ORDER];
  return {
    id: dto.personId,
    name: `${dto.firstName} ${dto.lastName}`,
    role: dto.ministryName,
    ministry: knownMinistries.includes(dto.ministryName)
      ? dto.ministryName as KnownMinistry
      : undefined,
  };
}
